export default __webpack_public_path__ + "8da5387a911f690ac2e5a289d61e7a00.svg";